export const APP_VERSION = 'aaab6096-1790676419955'
